module.exports = __webpack_public_path__ + "static/media/user-active.01791173.svg";